<div class="dialog-container">
  <div class="dialog-header">
    <pdq-heading element="h3">Create Custom Strategy</pdq-heading>
    <pdq-button icon="close" variant="ghost" [plain]="true" (onClick)="close()"></pdq-button>
  </div>

  <div class="dialog-body">
    <div class="row">
      <div class="field">
        <pdq-input
          label="Strategy Title*"
          size="medium"
          background="light"
          placeholder="Strategy Title"
          [control]="titleControl"
          [invalid]="submitted && titleControl.invalid"
          [invalidMsg]="submitted && titleControl.invalid ? 'Strategy Title is required' : ''">
        </pdq-input>
      </div>
      <div class="field">
        <pdq-dropdown
          title="Category*"
          [options]="categoryOptions"
          placeholder="Select category"
          [fullWidth]="true"
          [invalid]="submitted && categoryControl.invalid"
          [invalidMsg]="submitted && categoryControl.invalid ? 'Category is required' : ''"
          (onChange)="onCategoryChange($event)">
        </pdq-dropdown>
      </div>
    </div>

    <div class="field">
      <label class="field-label">Preview Image</label>
      <div class="upload-area" (click)="fileInput.click()">
        @if (previewUrl) {
          <div class="preview-image-container">
            <img [src]="previewUrl" alt="Preview" class="preview-image" />
            <pdq-button
              class="remove-preview"
              icon="close"
              variant="ghost"
              [plain]="true"
              (onClick)="removePreview(); $event.stopPropagation()">
            </pdq-button>
          </div>
        } @else {
          <p class="upload-text">Click to upload preview image</p>
        }
      </div>
      <input
        #fileInput
        type="file"
        accept="image/png,image/jpeg,image/webp"
        class="hidden-input"
        (change)="onFileSelected($event)" />
    </div>

    <div class="field">
      <pdq-dropdown
        title="Main KPIs"
        [options]="kpiOptions"
        placeholder="Select KPIs"
        [multiSelect]="true"
        [fullWidth]="true"
        [enableSearch]="true"
        selectBy="checked"
        (onMultiSelectChange)="onKpiChange($event)">
      </pdq-dropdown>
    </div>

    <div class="field">
      <pdq-dropdown
        title="Tags"
        [options]="tagOptions"
        placeholder="Select tags"
        [multiSelect]="true"
        [fullWidth]="true"
        [enableSearch]="true"
        selectBy="checked"
        (onMultiSelectChange)="onTagChange($event)">
      </pdq-dropdown>
    </div>

    <div class="field">
      <pdq-textarea
        label="Concept*"
        placeholder="Describe the strategy concept..."
        [control]="conceptControl"
        [rows]="4"
        [maxLength]="2000"
        [invalid]="submitted && conceptControl.invalid">
      </pdq-textarea>
      @if (submitted && conceptControl.invalid) {
        <span class="invalid-msg">*Concept is required</span>
      }
    </div>
  </div>

  <div class="dialog-footer">
    <pdq-button label="Cancel" variant="secondary" (onClick)="close()"></pdq-button>
    <pdq-button
      label="Create Strategy"
      variant="primary"
      [disabled]="submitting"
      [loading]="submitting"
      (onClick)="submit()">
    </pdq-button>
  </div>
</div>
